import React from "react";
import Grid2 from "@mui/material/Unstable_Grid2";
import PropTypes from "prop-types";
import MKTypography from "../../../components/MKTypography";
import MKButton from "../../../components/MKButton";
// import MKBox from "../../../components/MKBox";
import formatDatetime from "../../../utils/formatDatetime";

const JobsQueue = ({ jobs }) => {
  const nonAssignedJobs = jobs.filter((j) => j.status !== "Assigned");
  const sortedJobs = [...nonAssignedJobs].sort((a, b) => b.submission_time - a.submission_time);

  return (
    <Grid2 mx={{ sm: 3, xl: 12, xxl: 24, xxxl: 48 }}>
      <Grid2 xs={12} container maxWidth={1600} justifyContent="center" sx={{ display: "flex" }}>
        <Grid2 xs={12} item container sx={{ display: "flex" }} mr={2}>
          <Grid2 xs={2}>
            <MKTypography variant="h6" noWrap sx={{ textAlign: "center" }}>
              Job Name
            </MKTypography>
          </Grid2>
          <Grid2 xs={3}>
            <MKTypography variant="h6" noWrap sx={{ textAlign: "center" }}>
              Model
            </MKTypography>
          </Grid2>
          <Grid2 xs={1}>
            <MKTypography variant="h6" noWrap sx={{ textAlign: "center" }}>
              Status
            </MKTypography>
          </Grid2>
          <Grid2 xs={2}>
            <MKTypography variant="h6" noWrap sx={{ textAlign: "center" }}>
              Submission Time
            </MKTypography>
          </Grid2>
          <Grid2 xs={2}>
            <MKTypography variant="h6" noWrap sx={{ textAlign: "center" }}>
              Completion Time
            </MKTypography>
          </Grid2>
          <Grid2 xs={1.5} />
        </Grid2>
        <Grid2 xs={12} container width={1} mt={1} sx={{ overflow: "auto", height: "40vh" }}>
          {sortedJobs.map((item) => (
            <Grid2
              xs={12}
              container
              key={item.job_id}
              borderBottom={1}
              sx={{ display: "flex", alignItems: "center" }}
            >
              <Grid2 xs={2}>
                <MKTypography variant="body2" noWrap sx={{ textAlign: "center" }}>
                  {item.job_name}
                </MKTypography>
              </Grid2>
              <Grid2 xs={3}>
                <MKTypography variant="body2" noWrap sx={{ textAlign: "center" }}>
                  {item.job_desc}
                </MKTypography>
              </Grid2>
              <Grid2 xs={1}>
                <MKTypography variant="body2" noWrap sx={{ textAlign: "center" }}>
                  {item.status}
                </MKTypography>
              </Grid2>
              <Grid2 xs={2}>
                <MKTypography variant="body2" noWrap sx={{ textAlign: "center" }}>
                  {formatDatetime(item.submission_time)}
                </MKTypography>
              </Grid2>

              <Grid2 xs={2}>
                <MKTypography variant="body2" noWrap sx={{ textAlign: "center" }}>
                  {item.completion_time !== "" ? formatDatetime(item.completion_time) : ""}
                </MKTypography>
              </Grid2>
              <Grid2 xs={1.5} py={0.5} justifyContent="center" sx={{ display: "flex" }}>
                <MKButton
                  variant="contained"
                  color="secondary"
                  size="small"
                  href={`/computing/view/${item.job_id}`}
                  disabled={item.status === "pending"}
                >
                  View
                </MKButton>
              </Grid2>
            </Grid2>
          ))}
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

JobsQueue.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default JobsQueue;
